import { styled } from 'styled-components';
import { textExtraTinySemiBold, textTinySemiBold } from '../../Typography';

export const A = styled.a`
    display: inline-block;
    vertical-align: middle;
    ${textExtraTinySemiBold};
    color: var(--text-standard-secondary);
    border: 1px solid var(--black-600);
    background: var(--black-500);
    padding: var(--space-25);
    margin: 0;
    border-radius: 4px;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;

  &.medium {
    ${textTinySemiBold};
    padding: var(--space-50) var(--space-75);
  }
`;
